import { makeAutoObservable, runInAction } from "mobx";
import { when, action } from "mobx";
import { Api } from "../common/Api";
import { AdminStore } from "./admin/AdminStore";
import { EngToolStore } from "./engTool/EngToolStore";
import { FeedbacksStore } from "./FeedbacksStore";
import { FundsStore } from "./fundraising/FundsStore";
import { IdChecksStore } from "./idcheck/IdChecksStore";
import { OrgsStore } from "./org/OrgsStore";

export class RootStore {
  start = false;

  divisions: any[] = [];
  orgs: any[] = [];
  employees: any[] = [];
  timezones: string[] = [];

  curMenu = ["dashboard"];
  user = { username: "" };
  isAdmin = false;
  isDivision = false;
  unread = {
    feedback: 0,
    childUpdate: 0,
    idCheck: 0,
    fundPending: 0,
    orgPending: 0,
  };

  feedbacks: FeedbacksStore;
  orgsStore: OrgsStore;
  fundsStore: FundsStore;
  engTool: EngToolStore;
  idCheck: IdChecksStore;
  adminStore: AdminStore;

  constructor() {
    makeAutoObservable(this, {});

    this.orgsStore = new OrgsStore(this);
    this.fundsStore = new FundsStore(this);
    this.engTool = new EngToolStore(this);
    this.feedbacks = new FeedbacksStore(this);
    this.idCheck = new IdChecksStore(this);
    this.adminStore = new AdminStore(this);

    setInterval(() => this.updateUnreadMsg(), 1000 * 60 * 60);

    when(
      () => this.start,
      () => this.loadAll()
    );
  }

  @action
  loadAll() {
    // this.getDivisions();
    // this.getOrgs();
    // this.loadTimezone();
    this.orgsStore.refresh();
    this.fundsStore.refresh();
  }

  @action
  getDivisions() {
    return Api.division.list().then((res) => (this.divisions = res.data));
  }

  // @action
  // getOrgs() {
  //   return Api.org.list().then((res) => (this.orgs = res.data));
  // }

  @action loadTimezone() {
    return Api.timezone().then((res) => {
      this.timezones = res.data.data.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    });
  }

  @action setCurMenu(cur) {
    this.curMenu = cur;
  }

  @action updateUnreadMsg() {
    Api.me.unreadMsg().then((res) => {
      runInAction(() => {
        this.unread = res.data.unreadMsg;
      });
    });
  }

  @action
  getEmployees() {
    return Api.admin.list().then(async (res) => {
      const getAttr = (attributes, name) => {
        let attr = attributes.find((a) => a.name === name);
        return attr ? attr.value : "";
      };
      return (this.employees = res.data.map((x) => {
        const { enabled, userStatus, attributes } = x;
        let id = attributes.find((a) => a.name === "sub").value;
        let email = attributes.find((a) => a.name === "email").value;
        let role = attributes.find((a) => a.name === "custom:role");
        let name = getAttr(attributes, "name");
        return {
          id,
          username: name || "pswang",
          enabled,
          userStatus,
          email,
          role: role ? role.value : "Managing",
        };
      }));
    });
  }
}

export const Store = new RootStore();
